/** Services Sub-Admin / view-only users can list & view, but not edit. */
export function isViewOnly(user) {
  if (!user) return false;
  return (
    user.is_view_only === true ||
    user.is_view_only === 1 ||
    user.is_view_only === "1"
  );
}

export function canEdit(user) {
  return !!user && !isViewOnly(user);
}

export function isSuperAdmin(user) {
  return !!(user && (user.id == 1 || user.id == 3));
}

/** JC admin (department 1) or super admin (id 1 / 3). */
export function isAdminOrSuperAdmin(user) {
  return isSuperAdmin(user) || !!(user && user.department_id == 1);
}

/** OJC / OTHER JC branch job cards. */
export function isOjcTask(task) {
  if (!task) return false;
  return (
    task.branch?.branch_name === "OTHER JC" ||
    task.assiger_branch == 4
  );
}
